<template>
  <common-page-shell :tabs-site-nav-content="tabsSiteNavContent">
    <router-view />
  </common-page-shell>
</template>

<script>
import CommonPageShell from './CommonPageShell.vue';
import ROUTES from '@/constants/routes.constant';

export default {
  name: 'PageShell',
  components: {
    CommonPageShell,
  },
  data () {
    return {
      tabsSiteNavContent: [
        {
          text: 'Providers',
          id: ROUTES.PROVIDERS,
          active: false,
        },
        {
          text: 'Collection',
          id: ROUTES.COLLECTION,
          active: true,
        },
        {
          text: 'Snapshots',
          id: ROUTES.PREC,
          active: true,
        }
      ],
    };
  },
};
</script>
